<!--  -->
<template>
  <div class="tunnel">
    <img src="../../assets/leftdd.png" />
    <div class="right">
      <div class="itemone">
        <div v-for="(item,i) in dataone" :key="i" class="child">
          <span style="color:rgb(159, 211, 255);margin-right:10px">{{item.key}}</span>
          <span>{{item.value}}</span>
        </div>
      </div>
      <div class="item">
        <div class="title">基础信息</div>
        <div class="content overflow" style="height:10vh">
          <div v-for="(item,i) in datatwo" :key="i" class="child">
            <span style="color:rgb(159, 211, 255);margin-right:10px;min-width: 36px;">{{item.key}}</span>
            <span>{{item.value}}</span>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">设备信息</div>
        <div class="content overflow" style="height:19vh">
          <div v-for="(item,i) in datathree" :key="i" class="child">
            <span style="color:rgb(159, 211, 255);margin-right:10px;min-width: 36px;">{{item.key}}</span>
            <span>{{item.value}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataone: [
       
      ],
      datatwo: [],
      datathree: []
    };
  },

  components: {},

  computed: {},

  methods: {
    cmdata(val) {
      console.log(val, "ddd");
      if (val.data.records[0]) {
        this.datatwo = val.data.records[0].dat;
      }
      if (val.data.records[1]) {
        this.datathree = val.data.records[1].dat;
      }
      this.dataone = val.data.main.dat;
    }
  },

  mounted() {
    // console.log("dddd");
    window.cmdata = this.cmdata;
    this.emit.$on("item", e => {
      console.log(e, "dada333");
      // this.nowpage = e;
      if (e == 3) {
        console.log("掘进");
      }
    });
  },

  beforeDestroy() {
    console.log("销毁");
  }
};
</script>
<style lang="less" scoped>
.tunnel {
  display: flex;
  position: absolute;
  left: 10px;
  top: 18vh;
  img {
    height: 65vh;
  }
  .right {
    position: absolute;
    top: 4.7vh;
    left: 3vw;
    .itemone {
      width: 218.6px;
      height: 11.9vh;
      background: url(../../assets/btnbgone.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .child {
        height: 34%;
        width: 95%;
        margin-left: 5%;
        color: #fff;
        display: flex;
        align-items: center;
        font-size: 15px;
      }
    }
    .item {
      margin-top: 4.5vh;
      .title {
        width: 215px;
        height: 3.3vh;
        background: url(../../assets/titlebg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 14px;
      }
      .content {
        overflow: auto;
        .child {
          height: 3.5vh;
          width: 95%;
          margin-left: 5%;
          color: #fff;
          display: flex;
          align-items: center;
          font-size: 15px;
        }
      }
    }
  }
}
.overflow::-webkit-scrollbar {
  width: 4px;
}
.overflow::-webkit-scrollbar-track-piece {
  background-color: none;
} /* 滚动条的内层滑轨背景颜色 */

.overflow::-webkit-scrollbar-track {
  background-color: none;
} /* 滚动条的外层滑轨背景颜色 */

.overflow::-webkit-scrollbar-thumb {
  background-color: #141f35;
  border-radius: 20px;
} /* 滚动条的内层滑块颜色 */

.overflow::-webkit-scrollbar-button {
  background-color: #141f35;
  display: none;
} /* 滑轨两头的监听按钮颜色 */
</style>